import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import env from '../misc/env';
import { extractMessageFromError, retryOnNetworkFailure } from '../utils/errorUtil';
import { ScopeChangeRequestApi } from './API';
import ScopeChangeRequest from './ScopeChangeRequest';
var ScopeChangeRequestStore = /*#__PURE__*/function (_Store) {
  function ScopeChangeRequestStore() {
    var _this;
    _classCallCheck(this, ScopeChangeRequestStore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ScopeChangeRequestStore, [].concat(args));
    _this.scopeChangeRequests = _this.collection({
      model: ScopeChangeRequest
    });
    _this.api = new ScopeChangeRequestApi({
      baseURL: env.WORK_DOTNET_API,
      token$: _this.rootStore.authStore.token$
    });
    return _this;
  }
  _inherits(ScopeChangeRequestStore, _Store);
  return _createClass(ScopeChangeRequestStore, [{
    key: "isPromptClientApprovalEnabled",
    value: function isPromptClientApprovalEnabled() {
      var _this$rootStore$sessi, _this$rootStore$sessi2, _this$rootStore$sessi3;
      return Boolean((_this$rootStore$sessi = this.rootStore.sessionStore.workspace) === null || _this$rootStore$sessi === void 0 ? void 0 : (_this$rootStore$sessi2 = _this$rootStore$sessi.config) === null || _this$rootStore$sessi2 === void 0 ? void 0 : (_this$rootStore$sessi3 = _this$rootStore$sessi2.combined_pricing) === null || _this$rootStore$sessi3 === void 0 ? void 0 : _this$rootStore$sessi3.job_scope_prompt_client_approval);
    }

    /**
     * Returns scope change requests for the specified job in descending order by date created.
     *
     * @param jobId
     * @returns {ScopeChangeRequest[]}
     */
  }, {
    key: "forJobSortedByDate",
    value: function forJobSortedByDate(jobId) {
      return this.forJob(jobId).sort(function (a, b) {
        return parseInt(Date.parse(b.dateCreated)) - parseInt(Date.parse(a.dateCreated));
      });
    }

    /**
     * Returns scope change requests for the specified job.
     *
     * @param jobId The job ID to look up scope change requests for.
     * @returns {ScopeChangeRequest[]}
     */
  }, {
    key: "forJob",
    value: function forJob(jobId) {
      return this.scopeChangeRequests.filter(function (scopeChangeRequest) {
        return scopeChangeRequest.jobId === jobId;
      });
    }

    /**
     * Fetches scope change requests for the specified job.
     *
     * @param jobId
     * @returns
     */
  }, {
    key: "fetchScopeChangeRequestsForJob",
    value: (function () {
      var _fetchScopeChangeRequestsForJob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(jobId) {
        var _this2 = this;
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return retryOnNetworkFailure(function () {
                return _this2.api.listScopeChangeRequests(jobId);
              }).doneRetrying(function (e) {
                return _this2.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
              });
            case 2:
              response = _context.sent;
              return _context.abrupt("return", this.scopeChangeRequests.set(response));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchScopeChangeRequestsForJob(_x) {
        return _fetchScopeChangeRequestsForJob.apply(this, arguments);
      }
      return fetchScopeChangeRequestsForJob;
    }()
    /**
     * Approves a scope change request pending client approval for the specified job.
     *
     * @param jobId
     * @returns
     */
    )
  }, {
    key: "approveScopeChangeRequest",
    value: (function () {
      var _approveScopeChangeRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(jobId) {
        var _this3 = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.api.approveScopeChangeRequest(jobId).catch(function (e) {
                _this3.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              });
            case 2:
              _context2.next = 4;
              return this.fetchScopeChangeRequestsForJob(jobId);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function approveScopeChangeRequest(_x2) {
        return _approveScopeChangeRequest.apply(this, arguments);
      }
      return approveScopeChangeRequest;
    }()
    /**
     * Rejects a scope change request pending client approval for the specified job.
     *
     * @param jobId
     * @param reason
     * @returns
     */
    )
  }, {
    key: "rejectScopeChangeRequest",
    value: (function () {
      var _rejectScopeChangeRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(jobId, reason) {
        var _this4 = this;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.api.rejectScopeChangeRequest(jobId, reason).catch(function (e) {
                _this4.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              });
            case 2:
              _context3.next = 4;
              return this.fetchScopeChangeRequestsForJob(jobId);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function rejectScopeChangeRequest(_x3, _x4) {
        return _rejectScopeChangeRequest.apply(this, arguments);
      }
      return rejectScopeChangeRequest;
    }())
  }]);
}(Store);
export { ScopeChangeRequestStore as default };
//# sourceMappingURL=ScopeChangeRequestStore.js.map
